jQuery(document).ready(function ($) {
  $("#provider_dropdown").on("change", function () {
    $.post(
      ajax_object.ajaxurl,
      {
        provider: $(this).val(),
        package: $(document).find('#package_type').val(),
        action: "faircom_provider_dropdown_handler",
      },
      function (data) {
        //console.log(data);
        if (data) {
          $("#provider_selector_detail").html(data);
          var price = $(document).find(".provider_line_speed").val();
          $(document).find("#line_speed_price").html(price);
        } else {
          console.log("error");
        }
      }
    );
  });

  $(document).on("change", ".provider_line_speed", function (e) {
    var price = $(this).val();
    //console.log(price);
    $(document).find("#line_speed_price").html(price);
  });

  $(document).on("change", "#home_business_selector", function (e) {
    var type = $(this).val();
    var price;
    if (type == "home") {
      $(document).find("#line_speed_business").addClass("hide");
      $(document).find("#line_speed_home").removeClass("hide");
      price = $(document).find("#line_speed_home").val();
      $(document).find("#line_speed_price").html(price);
    }
    if (type == "business") {
      $(document).find("#line_speed_home").addClass("hide");
      $(document).find("#line_speed_business").removeClass("hide");
      price = $(document).find("#line_speed_business").val();
      $(document).find("#line_speed_price").html(price);
    }
  });

  $(document).on("change",".provider_line_speed_selector", function (e) {
    e.preventDefault();
    var price = $(this).val();
    $(this).closest('.package-wrapper').find('.package-price h2').text('R' + price);

    var name = $(this).closest('.package-header').find('.provider-title strong').text();
    var that = $(this);
    console.log($(that).find( " option:selected" ).attr('data-id'));

    $.ajax({
      type: 'POST',
      url: ajax_object.ajaxurl,
      data: {
        action: 'get_fair_features',
        prov_name: name,
        areas : selected_area,
        selected : $(that).find( " option:selected" ).text(),
        id: $(that).find( " option:selected" ).attr('data-id'),
       },
      success: function(data){
      var html = JSON.parse(data);
      that.closest('.provider').find('.package-features').html(html);

      },
      error: function(err) {
      console.log(err)
    }
    })
  });
});
